module.exports = __webpack_public_path__ + "static/media/Icon_6.52c8fcd3.svg";